/* eslint-disable camelcase */

export class Campaign {
	constructor({
		id,
		name,
		slug,
		feedback_url,
		feedbacks
	} = {}) {
		this._id = id;
		this._name = name;
		this._slug = slug;
		this._feedback_url = feedback_url;
		this._feedbacks = feedbacks;
	}

	getId = () => this._id;

	getKey = () => String(this._slug);

	getName = () => this._name;

	getSlug = () => this._slug;

	getFeedbackUrl = () => this._feedback_url;

	getCountFeedback = () => String(this._feedbacks);
}

export class Feedback {
	constructor({
		id,
		organization,
		text,
		operator,
		created
	} = {}) {
		this._id = id;
		this._organization = organization;
		this._text = text;
		this._operator = operator;
		this._created = created;
	}

	getId = () => this._id;

	getText = () => this._text;

	getKey = () => String(this._id)

	getOrganization = () => this._organization;

	getOperator = () => this._operator;

	getOperatorEmail = () => this._operator['email'];

	getOperatorName = () => `${this._operator['first_name']} ${this._operator['last_name']}`;

	getCreated = () => this._created;
}